import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for Array
 * Serialized format is a JSON stringified representation of the object
 */
export const arraySerializer = CreateSerializer(serializeArray, deserializeArray, false);
function serializeArray(value) {
    return JSON.stringify(value);
}
function deserializeArray(value) {
    return JSON.parse(value);
}
